import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import AccountPayable from "../../../containers/modules/report/account-payable";

export default function AccountPayableRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="account-payable"
      index
      element={
        <AccessControl
          name={"Account Payable Show"}
          auth={authUser}
          component={() => <AccountPayable />}
        />
      }
    ></Route>
  );
}
